import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>

      <h2>Information We Collect</h2>
      <p>
        When you visit the site, we automatically collect certain information
        about your device, including information about your web browser, IP
        address, time zone, and some of the cookies installed on your device.
        Additionally, as you browse the site, we collect information about the
        individual web pages or products that you view, what websites or search
        terms referred you to the site, and how you interact with the site. We
        refer to this automatically collected information as “Device
        Information.”
      </p>

      <h2>How We Use Your Information</h2>
      <p>
        We use the information that we collect to fulfill orders placed through
        the site, process payments, arrange for shipping, and provide you with
        invoices and/or order confirmations. Additionally, we use this
        information to:
      </p>

      <ul>
        <li>Communicate with you;</li>
        <li>Screen orders for potential risk or fraud;</li>
        <li>
          Provide you with information or advertising related to our products or
          services (in line with preferences you’ve shared with us).
        </li>
      </ul>

      <h2>Sharing Your Information</h2>
      <p>
        We share your personal information with third parties to help us use
        your personal information as described above. For example, we use
        Shopify to power our online store—you can read more about how Shopify
        uses your personal information here:{" "}
        <a
          href="https://www.shopify.com/legal/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Shopify Privacy Policy
        </a>
        .
      </p>
      <p>
        We also use Google Analytics to help us understand how our customers use
        the site—you can read more about how Google uses your personal
        information here:{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Privacy Policy
        </a>
        .
      </p>

      <h2>Your Rights</h2>
      <p>
        If you are a resident of Europe, you have the right to access personal
        information we hold about you and to ask that your personal information
        be corrected, updated, or deleted. If you would like to exercise this
        right, please contact us.
      </p>

      <h2>Data Retention</h2>
      <p>
        When you place an order through the site, we will maintain your order
        information for our records unless and until you ask us to delete this
        information.
      </p>

      <h2>Changes</h2>
      <p>
        We may update this privacy policy from time to time to reflect changes
        to our practices or for other operational, legal, or regulatory reasons.
      </p>

      <h2>Contact Us</h2>
      <p>
        For more information about our privacy practices, if you have questions,
        or if you would like to make a complaint, please contact us by email at{" "}
        <a href="#">
          rubiacare@gmail.com
        </a>
        .
      </p>
    </div>
  );
};

export default PrivacyPolicy;